// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { GuidedChangeEventPage_ChangeEventFragmentDoc } from '../../GuidedChangeEventPage.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ReviewStep_SaveChangeEventMutationVariables = Types.Exact<{
  input: Types.SaveChangeEventInput;
}>;


export type ReviewStep_SaveChangeEventMutation = { __typename?: 'Mutation', saveChangeEvent: { __typename?: 'SaveChangeEventResult', changeEvent: { __typename?: 'ChangeEvent', id: string, title: string, internalNote?: string | null | undefined, hasPreSignedContract: boolean, status: Types.ChangeEventStatus, type: { __typename?: 'ChangeEventTypeDetail', code: Types.ChangeEventType }, workflow?: { __typename?: 'ChangeEventWorkflowDetail', code: Types.ChangeEventWorkflow } | null | undefined, reason: { __typename?: 'ChangeEventReason', id: string }, projectStage: { __typename?: 'ProjectStage', id: string }, materialVariantSwaps: Array<{ __typename?: 'ChangeEventMaterialVariantSwap', id: string, isPlanBasedSwap: boolean, proposedMaterialVariantWasCreated: boolean, totalCostInCents: number, totalPriceInCents: number, originalProjectItem: { __typename?: 'ProjectItem', id: string }, proposedMaterialVariant: { __typename?: 'MaterialVariant', id: string } }> } } };


export const ReviewStep_SaveChangeEventDocument = gql`
    mutation ReviewStep_SaveChangeEvent($input: SaveChangeEventInput!) {
  saveChangeEvent(input: $input) {
    changeEvent {
      ...GuidedChangeEventPage_ChangeEvent
    }
  }
}
    ${GuidedChangeEventPage_ChangeEventFragmentDoc}`;

/**
 * __useReviewStep_SaveChangeEventMutation__
 *
 * To run a mutation, you first call `useReviewStep_SaveChangeEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewStep_SaveChangeEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewStepSaveChangeEventMutation, { data, loading, error }] = useReviewStep_SaveChangeEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewStep_SaveChangeEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReviewStep_SaveChangeEventMutation, ReviewStep_SaveChangeEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReviewStep_SaveChangeEventMutation, ReviewStep_SaveChangeEventMutationVariables>(ReviewStep_SaveChangeEventDocument, options);
      }
export type ReviewStep_SaveChangeEventMutationHookResult = ReturnType<typeof useReviewStep_SaveChangeEventMutation>;
export type ReviewStep_SaveChangeEventMutationResult = ApolloReactCommon.MutationResult<ReviewStep_SaveChangeEventMutation>;